<script setup lang="ts">
  import { computed, ref, onMounted } from 'vue'
  import translaters from 'tradutors/assine'
  import { localeStore } from 'stores/locale'
  import { assineChoiceStore } from 'stores/assineChoice'
  import { userStore } from 'stores/user'
  import { useRoute } from 'vue-router'
  import { Carousel, Slide, Pagination } from 'vue3-carousel'
  import { isMobile } from '../../views/shared/utils/mobile'
  import router from 'router'
  import AssineCreditsInformations from 'components/Assine/AssineCreditsInformations.vue'

  const storeLocale = localeStore()
  const storeUser = userStore()
  const storeAssineChoice = assineChoiceStore()
  const route = useRoute()
  const emit = defineEmits(['showModalMessages'])

  const props = defineProps(['plansCredits'])
  const isActiveUser = computed(() => storeUser.isActiveUser)
  const isLoggedIn = computed(() => storeUser.isLoggedIn)

  const disparobegin = ref(false)
  const disparoplan = ref('')

  const settings = ref({
    itemsToShow: 1.05,
    mouseDrag: false
  })
  const breakpoints = ref({
    600: {
      itemsToShow: 2
    }
  })

  onMounted(() => {
    if (props.plansCredits) {
      var value = decimalParaCentavos(0)
      let element = props.plansCredits[1]

      value =
        element.discount > 0 && element.discount_value ? element.discount_value : element.value

      window.dataLayer = window.dataLayer || []
      if (!disparobegin.value) {
        disparobegin.value = true
        window.dataLayer.push({
          event: 'begin_checkout',
          begin_checkout: {
            tipo: 'Créditos',
            valor: value,
            acionador: route.query.acionador ?? 'link direto',
            currency: reactiveLocale.value === 'pt-br' ? 'BRL' : 'USD'
          }
        })
      }
    }
  })

  const reactiveLocale = computed(() => storeLocale.locale) // Certifique-se de que locale é uma ref

  const translate = computed(() => {
    if (reactiveLocale.value === 'pt-br') {
      return translaters.portugues
    } else {
      return translaters.ingles
    }
  })

  function saveChoiceAssinante() {
    let checkRadio = document.querySelector('input[name="plansCreditsAssinante"]:checked')
    if (checkRadio != null) {
      storeAssineChoice.setAssineChoice({
        choiceId: parseInt(checkRadio.value),
        choiceType: 'credits'
      })
      handleChange(parseInt(checkRadio.value))
      if (!isActiveUser.value) {
        emit('showModalMessages', {
          message: {
            show: true,
            title: reactiveLocale.value == 'pt-br' ? 'Aviso' : 'Notice',
            textButton: reactiveLocale.value == 'pt-br' ? 'Login' : 'Login',
            textBoby: translate.value.credits.subscribeInfo,
            routerName: 'LoginPage'
          }
        })
      } else {
        redirect('AssinePaymentPage')
      }
    } else {
      emit('showModalMessages', {
        message: {
          show: true,
          title: reactiveLocale.value == 'pt-br' ? 'Aviso' : 'Notice',
          textButton: reactiveLocale.value == 'pt-br' ? 'Fechar' : 'Close',
          textBoby:
            reactiveLocale.value == 'pt-br'
              ? 'Escolha uma opção para Assinantes'
              : 'Choose an option for Subscribers'
        }
      })
    }
  }

  function saveChoiceNaoAssinante() {
    let checkRadio = document.querySelector('input[name="plansCreditsNaoAssinante"]:checked')
    if (checkRadio != null) {
      storeAssineChoice.setAssineChoice({
        choiceId: parseInt(checkRadio.value),
        choiceType: 'credits'
      })
      handleChange(parseInt(checkRadio.value))
      if (isLoggedIn.value) {
        redirect('AssinePaymentPage')
      } else {
        redirect('AssineAccountPage')
      }
    } else {
      emit('showModalMessages', {
        message: {
          show: true,
          title: reactiveLocale.value == 'pt-br' ? 'Aviso' : 'Notice',
          textButton: reactiveLocale.value == 'pt-br' ? 'Fechar' : 'Close',
          textBoby:
            reactiveLocale.value == 'pt-br'
              ? 'Escolha uma opção para Não Assinantes'
              : 'Choose an option for Non-Subscribers'
        }
      })
    }
  }

  function redirect(name) {
    router.push({
      name,
      params: {
        locale: reactiveLocale.value
      }
    })
  }

  function decimalParaCentavos(numeroDecimal) {
    // Divide o número decimal por 100 para obter o valor em centavos
    var valorCentavos = Number(numeroDecimal) / 100

    // Formata o valor com duas casas decimais
    var valorFormatado = valorCentavos.toFixed(2)

    // Retorna o valor formatado como uma string
    return valorFormatado.replace('.', ',')
  }

  function handleChange(choiceId) {
    var value = decimalParaCentavos(0)
    props.plansCredits.forEach((element) => {
      if (element.id == choiceId) {
        value =
          element.discount > 0 && element.discount_value ? element.discount_value : element.value
      }
    })

    window.dataLayer = window.dataLayer || []
    if (!disparobegin.value) {
      disparobegin.value = true
      window.dataLayer.push({
        event: 'begin_checkout',
        begin_checkout: {
          tipo: 'Créditos',
          valor: value,
          acionador: route.query.acionador ?? 'link direto',
          currency: reactiveLocale.value === 'pt-br' ? 'BRL' : 'USD'
        }
      })
    }
    if (disparoplan.value != value) {
      window.dataLayer.push({
        event: 'select_plan',
        select_plan: {
          tipo: 'Créditos',
          valor: value,
          currency: reactiveLocale.value === 'pt-br' ? 'BRL' : 'USD'
        }
      })
      disparoplan.value = value
    }
  }
</script>

<template>
  <div class="row d-flex justify-content-center">
    <div class="col-lg-9">
      <Carousel v-bind="settings" :breakpoints="breakpoints">
        <Slide key="0">
          <div class="card">
            <div class="card-body justify-content-center">
              <div class="credit-title">{{ translate.credits.PlansAssi }}</div>
              <div class="credit-subtitle">{{ translate.credits.option }}</div>
              <div class="credit-hr"></div>
              <div
                class="row d-flex align-items-center justify-content-center"
                v-for="(item, index) in props.plansCredits"
                :key="item.id"
                :class="{ 'bg-gray': index % 2 !== 0 }"
              >
                <div
                  class="credit-discount"
                  v-if="index == 0 && item.discount > 0 && item.discount_value"
                >
                  <div>{{ translate.PromotionSpecial }}</div>
                  <div>{{ item.discount }} % {{ translate.labelDiscont }}</div>
                </div>
                <div v-if="index > 0" class="col-12 d-flex justify-content-end">
                  <div class="col-10 credit-items-hr"></div>
                </div>
                <div class="col-2 credit-items">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="plansCreditsAssinante"
                    :value="item.id"
                  />
                </div>
                <div class="col-5 credit-items credit-amount">
                  {{ item.creditVideosAssinantes }}
                  {{ reactiveLocale == 'en' ? 'credits' : 'créditos' }}
                </div>
                <div class="col-5 credit-items">
                  <div class="credit-value-cancel" v-if="item.discount > 0 && item.discount_value">
                    {{ reactiveLocale === 'pt-br' ? 'De ' : 'Of ' }} 
                    {{ reactiveLocale != 'pt-br' ? '$' : '' }}
                    {{ item.value }}
                  </div>
                  <span class="credit-value" v-if="item.discount > 0 && item.discount_value">
                    {{ reactiveLocale === 'pt-br' ? 'Por ' : 'Only ' }} 
                    {{ reactiveLocale != 'pt-br' ? '$' : '' }}                    
                    <span>{{ item.discount_value.toString().split('.')[0] }},</span>
                    <span class="credit-value-cents">
                      {{ item.discount_value.toString().split('.')[1] }}
                    </span>
                  </span>
                  <span class="credit-value" v-if="!item.discount_value">
                    {{ reactiveLocale != 'pt-br' ? '$' : '' }}
                    <span>{{ item.value.toString().split('.')[0] }},</span>
                    <span class="credit-value-cents">
                      {{ item.value.toString().split('.')[1] }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="row d-flex align-items-center justify-content-center">
                <button
                  type="button"
                  class="credit-button col-lg-3 col-8"
                  @click="saveChoiceAssinante()"
                >
                  {{ translate.buttonCredits2 }}
                </button>
              </div>
              <div class="d-flex justify-content-center" v-if="isMobile()">
                <div class="col-12">
                  <vue-collapsible-panel-group base-color="#2d2b3b">
                    <vue-collapsible-panel :expanded="false">
                      <template #title>
                        <div class="details">{{ translate.moreDetails }}</div>
                      </template>
                      <template #content>
                        {{ ' ' }}
                        <div class="col-12">
                          <ul class="bulleted-list">
                            <li
                              v-for="(list, index) in translate.credits.listBenefits"
                              :key="index"
                            >
                              <p class="ps-2 list-items" v-html="list"></p>
                            </li>
                          </ul>
                        </div>
                      </template>
                    </vue-collapsible-panel>
                  </vue-collapsible-panel-group>
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex mt-3">
            <div class="credits-subs-hiffen">-</div>
            <div class="credits-subs-info">{{ translate.credits.subscribeInfo }}</div>
          </div>
        </Slide>
        <Slide key="1">
          <div :class="`card ${isActiveUser && isLoggedIn ? 'card-gray' : ''}`">
            <div class="card-body justify-content-center">
              <div class="credit-title">{{ translate.credits.PlansNoAssi }}</div>
              <div class="credit-subtitle">{{ translate.credits.option }}</div>
              <div class="credit-hr"></div>
              <div
                class="row d-flex align-items-center justify-content-center"
                v-for="(item, index) in props.plansCredits"
                :key="item.id"
                :class="{ 'bg-gray': index % 2 !== 0 }"
              >
                <div
                  class="credit-discount"
                  v-if="index == 0 && item.discount > 0 && item.discount_value"
                >
                  <div>{{ translate.PromotionSpecial }}</div>
                  <div>{{ item.discount }} % {{ translate.labelDiscont }}</div>
                </div>
                <div v-if="index > 0" class="col-12 d-flex justify-content-end">
                  <div class="col-10 credit-items-hr"></div>
                </div>
                <div class="col-2 credit-items">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="plansCreditsNaoAssinante"
                    :value="item.id"
                  />
                </div>
                <div class="col-5 credit-items credit-amount">
                  {{ item.creditVideosNaoAssinantes }}
                  {{ reactiveLocale == 'en' ? 'credits' : 'créditos' }}
                </div>
                <div class="col-5 credit-items">
                  <div class="credit-value-cancel" v-if="item.discount > 0 && item.discount_value">
                    {{ reactiveLocale === 'pt-br' ? 'De ' : 'Of ' }} 
                    {{ reactiveLocale != 'pt-br' ? '$' : '' }}                    
                    {{ item.value }}
                  </div>
                  <span class="credit-value" v-if="item.discount > 0 && item.discount_value">
                    {{ reactiveLocale === 'pt-br' ? 'Por ' : 'Only ' }} 
                    {{ reactiveLocale != 'pt-br' ? '$' : '' }}                    
                    <span>{{ item.discount_value.toString().split('.')[0] }},</span>
                    <span class="credit-value-cents">
                      {{ item.discount_value.toString().split('.')[1] }}
                    </span>
                  </span>
                  <span class="credit-value" v-if="!item.discount_value">
                    {{ reactiveLocale != 'pt-br' ? '$' : '' }}                    
                    <span>{{ item.value.toString().split('.')[0] }},</span>
                    <span class="credit-value-cents">
                      {{ item.value.toString().split('.')[1] }}
                    </span>
                  </span>
                </div>
              </div>
              <div class="row d-flex align-items-center justify-content-center">
                <button
                  v-if="isActiveUser && isLoggedIn"
                  type="button"
                  class="credit-button-inactive col-lg-3 col-8`"
                >
                  {{ translate.buttonCredits2 }}
                </button>
                <button
                  v-else
                  type="button"
                  class="credit-button col-lg-3 col-8`"
                  @click="saveChoiceNaoAssinante()"
                >
                  {{ translate.buttonCredits2 }}
                </button>
              </div>
              <div class="d-flex justify-content-center" v-if="isMobile()">
                <div class="col-12">
                  <vue-collapsible-panel-group base-color="#2d2b3b">
                    <vue-collapsible-panel :expanded="false">
                      <template #title>
                        <div class="details">{{ translate.moreDetails }}</div>
                      </template>
                      <template #content>
                        {{ ' ' }}
                        <div class="col-12">
                          <ul class="bulleted-list">
                            <li
                              v-for="(list, index) in translate.credits.listBenefits"
                              :key="index"
                            >
                              <p class="ps-2 list-items" v-html="list"></p>
                            </li>
                          </ul>
                        </div>
                      </template>
                    </vue-collapsible-panel>
                  </vue-collapsible-panel-group>
                </div>
              </div>
            </div>
          </div>
        </Slide>
        <template #addons v-if="isMobile()">
          <Pagination />
        </template>
      </Carousel>
      <div class="container col-lg-12 col-12 py-5" v-if="!isMobile()">
        <AssineCreditsInformations />
      </div>
    </div>
  </div>
</template>

<style scoped lang="css">
  .card {
    border: 3px solid #6fa923;
    width: 95%;
    margin-top: 50px;
    padding-right: 0px;
    border: solid 3px transparent;
    background: linear-gradient(#ffffff, #ffffff) padding-box,
      radial-gradient(98.54% 262.92% at 1.46% 0%, #6fa923 0%, #7de644 100%) border-box;
    border-radius: 25px 25px 0 0;
  }

  .card-gray {
    background: linear-gradient(#ffffff, #ffffff) padding-box,
      radial-gradient(98.54% 262.92% at 1.46% 0%, #eaeaea 0%, #cccccc 100%) border-box !important;
  }

  .credit-title {
    font-family: 'Exo-2';
    font-weight: 700;
    font-size: 28.28px;
    line-height: 33.94px;
    color: #000000;
    padding-top: 10px;
  }

  .credit-subtitle {
    font-family: 'Exo-2';
    font-weight: 400;
    font-size: 15.56px;
    line-height: 18.67px;
    color: #4b4b4b;
    padding-top: 20px;
  }

  .credit-hr {
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 10px;
    border-top: 1px solid #9d9d9d;
    width: 80%;
  }

  .credit-items {
    padding: 20px 0px;
  }

  .credit-items-hr {
    border-top: 1px solid #dedede;
    right: 10px;
  }

  .credit-amount {
    font-family: 'Exo-2';
    font-weight: 300;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
  }

  .credit-value {
    font-family: 'Exo-2';
    font-weight: 800;
    font-size: 20px;
    line-height: 24px;
    color: #000000;
  }

  .credit-value-cents{
    font-size: 13px;
  }  

  .credit-value-cancel {
    font-family: 'Exo-2';
    font-weight: 400;
    font-size: 15px;
    line-height: 19px;
    color: #b20000;
    text-decoration: line-through;
  }

  .credit-button {
    width: 206px;
    height: 46px;
    background-color: #6ca727 !important;
    border-radius: 15px !important;
    font-family: 'Exo-2';
    font-weight: 700;
    font-size: 19.8px;
    line-height: 23.76px;
    color: #ffffff;
    margin-top: 30px;
    margin-bottom: 20px;
  }

  .credit-button-inactive {
    width: 206px;
    height: 46px;
    background-color: #eaeaea !important;
    border-radius: 15px !important;
    font-family: 'Exo-2';
    font-weight: 700;
    font-size: 19.8px;
    line-height: 23.76px;
    color: #ffffff;
    margin-top: 30px;
    margin-bottom: 20px;
    cursor: not-allowed;
  }

  .credits-subs-hiffen {
    font-family: 'Exo-2';
    font-weight: 300;
    font-size: 12px;
    line-height: 14.4px;
    color: #4b4b4b;
  }
  .credits-subs-info {
    text-align: justify;
    width: 90%;
    left: 10px;
    font-family: 'Exo-2';
    font-weight: 300;
    font-size: 12px;
    line-height: 14.4px;
    color: #4b4b4b;
  }
  .form-check-input:checked[type='radio'] {
    --bs-form-check-bg-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'%3e%3ccircle r='2' fill='%23000'/%3e%3c/svg%3e");
  }

  .form-check-input:checked {
    background-color: #ffffff;
    border-color: #000;
  }

  .form-check-input {
    --bs-form-check-bg: #fff;
    width: 24px;
    height: 24px;
    left: 15px;
  }

  .carousel__slide {
    display: inline;
  }

  :deep(.carousel__viewport) {
    left: 25px;
  }

  :deep(.carousel__pagination-button::after) {
    display: block;
    content: '';
    width: 12px;
    height: 12px;
    border-radius: 50%;
    opacity: 0.2;
    background-color: #000000;
    margin-right: 15px;
    top: -3px;
    left: -2px;
  }

  :deep(.carousel__pagination-button--active) {
    background-color: #000000;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    margin-right: 15px;
  }

  .carousel__pagination {
    left: 20px;
  }

  .vcpg {
    border: none !important;
  }

  .vcpg :deep(.vcp__header) {
    background-color: unset !important;
    border: 0;
    width: 70%;
    margin-left: 50%;
    transform: translateX(-50%);
  }

  .details {
    font-family: 'Roboto-Medium';
    font-weight: 400;
    font-size: 17px;
    line-height: 19px;
    color: #000000;
  }

  .list-items {
    font-family: 'Roboto-Regular';
    font-weight: 400;
    font-size: 11px;
    line-height: 12.89px;
    color: #000000;
    text-align: left;
  }

  .bulleted-list {
    list-style-type: disc;
    margin-left: 20px;
  }
  .bulleted-list li {
    margin-bottom: 0px;
    text-align: left;
  }

  .footer-list {
    color: #5b5858;
    font-family: 'Roboto-Regular';
    font-size: 13px;
    font-style: italic;
    letter-spacing: 0;
    line-height: 15px;
    padding-top: 30px;
    text-align: left;
  }

  .credit-discount {
    font-family: 'Exo-2';
    font-weight: 700;
    font-size: 21.2px;
    line-height: 25.44px;
    color: #436a10;
    padding-top: 20px;
  }
  /* regras mobile 769px */
  @media screen and (max-width: 769px) {
    .credit-amount {
      font-size: 16px;
      line-height: 19.2px;
      left: 0px;
    }

    .credit-value {
      font-size: 16px;
      line-height: 19.2px;
    }
  }
</style>
